"use client"

import type { ReactNode } from "react"
import { motion } from "framer-motion"

const HOME_FEATURES: {
  id: string
  tag: string
  title: string
  body: string
  foot: string
  okFoot: string
  wide?: boolean
  glyph: ReactNode
}[] = [
  {
    id: "F01",
    tag: "TGE.TARGET",
    title: "Targeted,\nNot Theatre.",
    body: "TGE TARGETED FOR 19 SEPTEMBER 2026 — SUBJECT TO INDEPENDENT AUDIT COMPLETION AND LEGAL-ENTITY SETUP.",
    foot: "TARGET · 19 SEP 2026",
    okFoot: "ON TRACK",
    wide: true,
    glyph: (
      <svg width="120" height="120" viewBox="0 0 120 120" aria-hidden>
        <rect x="20" y="20" width="80" height="80" fill="none" stroke="#8fbfa8" strokeWidth="1" />
        <rect x="32" y="32" width="56" height="56" fill="none" stroke="#8fbfa8" strokeWidth="0.5" />
        <line x1="60" y1="20" x2="60" y2="100" stroke="#8fbfa8" strokeWidth="0.5" strokeDasharray="2 3" />
        <line x1="20" y1="60" x2="100" y2="60" stroke="#8fbfa8" strokeWidth="0.5" strokeDasharray="2 3" />
        <circle cx="60" cy="60" r="6" fill="#8fbfa8" />
        <circle cx="60" cy="60" r="14" fill="none" stroke="#8fbfa8" strokeOpacity={0.5} />
      </svg>
    ),
  },
  {
    id: "F02",
    tag: "FOUNDER.LOCK",
    title: "12-Month Vest.",
    body: "12% FOUNDER ALLOCATION LOCKED FOR 365 DAYS POST-TGE. 0% UNLOCKED AT LAUNCH.",
    foot: "VEST CONTRACT · TBD AT TGE",
    okFoot: "VEST LOCK",
    glyph: (
      <svg width="80" height="80" viewBox="0 0 80 80" aria-hidden>
        <rect x="18" y="34" width="44" height="32" fill="none" stroke="#c9a96a" strokeWidth="1" />
        <path d="M24 34 V24 a16 16 0 0 1 32 0 V34" fill="none" stroke="#c9a96a" strokeWidth="1" />
        <circle cx="40" cy="48" r="4" fill="#c9a96a" />
        <line x1="40" y1="48" x2="40" y2="58" stroke="#c9a96a" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    id: "F03",
    tag: "COMMUNITY.30",
    title: "30% Mined.",
    body: "300M RIVYU DISTRIBUTED THROUGH FAIR MINING.",
    foot: "FAIR MINING ON-CHAIN",
    okFoot: "STREAMING",
    glyph: (
      <svg width="80" height="80" viewBox="0 0 80 80" aria-hidden>
        <circle cx="40" cy="40" r="22" fill="none" stroke="#8fbfa8" strokeWidth="1" />
        <circle cx="40" cy="40" r="14" fill="none" stroke="#8fbfa8" strokeWidth="0.5" strokeDasharray="2 2" />
        {[0, 1, 2, 3, 4, 5].map((i) => {
          const a = (i / 6) * Math.PI * 2
          return <circle key={i} cx={40 + Math.cos(a) * 22} cy={40 + Math.sin(a) * 22} r="3" fill="#8fbfa8" />
        })}
      </svg>
    ),
  },
  {
    id: "F04",
    tag: "STAKING.TIERS",
    title: "Up to 60% APY.",
    body: "4 TIERED POOLS. CORE FLEX (5%) → CRYO STASIS (12%) → DEEP FREEZE (25%) → ABSOLUTE ZERO (60%).",
    foot: "200M ALLOCATED",
    okFoot: "STAKING LIVE",
    glyph: (
      <svg width="100" height="80" viewBox="0 0 100 80" aria-hidden>
        {[0, 1, 2, 3].map((i) => (
          <rect
            key={i}
            x={10 + i * 22}
            y={70 - (i + 1) * 14}
            width="16"
            height={(i + 1) * 14}
            fill="none"
            stroke="#00e5ff"
            strokeOpacity={0.4 + i * 0.2}
          />
        ))}
      </svg>
    ),
  },
  {
    id: "F05",
    tag: "TON.NATIVE",
    title: "TON-Native\nfrom Day 0.",
    body: "BUILT ON TEP-74 JETTON STANDARD. INFINITE SCALABILITY, SUB-CENT FEES, FULL ECOSYSTEM INTEROP WITH WALLETS, DEXS, AND BRIDGES.",
    foot: "TON.MAINNET · TEP-74",
    okFoot: "TEP-74",
    wide: true,
    glyph: (
      <svg width="120" height="120" viewBox="0 0 120 120" aria-hidden>
        <polygon points="60,18 100,40 60,108 20,40" fill="none" stroke="#8fbfa8" strokeWidth="1" />
        <polygon points="60,18 100,40 60,60 20,40" fill="rgba(143,191,168,0.08)" stroke="#8fbfa8" strokeWidth="0.5" />
        <line x1="60" y1="18" x2="60" y2="60" stroke="#8fbfa8" strokeWidth="0.5" />
        <text x="60" y="78" textAnchor="middle" fill="#8fbfa8" fontSize="9" fontFamily="var(--mono)" letterSpacing="3">
          TON
        </text>
      </svg>
    ),
  },
  {
    id: "F06",
    tag: "AUDIT.PENDING",
    title: "Audit\nPending.",
    body: "AI-ASSISTED TSA PASS (APR 2026) — FINDINGS REMEDIATED MAY 2026 WITH REGRESSION TESTS. INDEPENDENT FIRM AUDIT PLANNED PRE-MAINNET. BUG BOUNTY IN PREPARATION. EVERY ADDRESS PUBLIC.",
    foot: "AUDITS/MAY-2026",
    okFoot: "TSA_DONE",
    glyph: (
      <svg width="80" height="80" viewBox="0 0 80 80" aria-hidden>
        <rect x="20" y="16" width="40" height="50" fill="none" stroke="#c9a96a" strokeWidth="1" />
        <line x1="26" y1="28" x2="54" y2="28" stroke="#c9a96a" strokeWidth="0.5" />
        <line x1="26" y1="36" x2="54" y2="36" stroke="#c9a96a" strokeWidth="0.5" />
        <line x1="26" y1="44" x2="46" y2="44" stroke="#c9a96a" strokeWidth="0.5" />
        <text x="40" y="58" textAnchor="middle" fill="#c9a96a" fontSize="8" fontFamily="var(--mono)" letterSpacing="3">
          TBD
        </text>
      </svg>
    ),
  },
]

export function FeaturesSection() {
  return (
    <motion.section
      className="ft-wrap"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: [0, 0, 0.2, 1] }}
    >
      <div className="ft-head">
        <h2>
          Why <span className="accent">Rivyu_</span>
        </h2>
        <p className="sr-only">
          Six protocol mechanics. On a phone or tablet, tap a card for detail. With a mouse, hover for
          detail.
        </p>
        <div className="legend" aria-hidden>
          <span className="ft-legend-touch">// SIX MECHANICS · TAP FOR DETAIL</span>
          <span className="ft-legend-hover">// SIX MECHANICS · HOVER FOR DETAIL</span>
        </div>
      </div>
      <div className="ft-grid">
        {HOME_FEATURES.map((f) => (
          <div key={f.id} className={`ft-cell${f.wide ? " wide" : ""}`}>
            <div className="head-line">
              <span>// {f.tag}</span>
              <span className="right">{f.id}</span>
            </div>
            <h3 style={{ whiteSpace: "pre-line" }}>{f.title}</h3>
            <p>{f.body}</p>
            <div className="glyph">{f.glyph}</div>
            <div className="footer-line">
              <span>{f.foot}</span>
              <span className="ok">◆ {f.okFoot}</span>
            </div>
          </div>
        ))}
      </div>
    </motion.section>
  )
}
